import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
    typography: {
      fontFamily: ['Urbanist'].join(',')
     }
   })

export default theme;